import TrialLayout from "./TrialLayout";

export default TrialLayout;
